import { Link } from "@postenbring/hedwig-react";

const PickupPoint = ({ pickupPoint, localization, mapUrl }) => {
  const pickupPoints = Array.isArray(pickupPoint) ? pickupPoint : [pickupPoint];
  return pickupPoints.filter(Boolean).map((point, index) => {
    const details = [point.openingHours, point.visitingAddress && point.visitingAddress.csv]
      .filter(Boolean)
      .join(", ");

    return (
      <div key={point.unitNumber || point.heading || index}>
        <p>
          <span style={{ color: "var(--hds-colors-dark)" }}>{localization.pickupPlace}:</span>{" "}
          {point.heading}
        </p>
        <p>{details}</p>
        <Link href={mapUrl + "?ID=" + point.unitNumber} aria-describedby={"hit-" + index}>
          {localization.address.linkLabel}
        </Link>
      </div>
    );
  });
};

export default PickupPoint;
